import { useEffect, useState } from 'react'
import { HandleClickOutside } from '../../../../common/HandleClickOutside'
import { UseTheme } from '../../../../common/hooks/useTheme'
import { UseTypeFontSize } from '../../../../common/hooks/useTypeFontSize'
import { Element } from '../../../../common/html/element'
import { getStyle } from '../../../../common/html/helper'
import { Icon } from '../../../../common/html/icon'
import { TextEllipsisStaticLine } from '../../../../common/textEllipsis/TextEllipsisStaticLine'
import { Z_INDEX } from '../../../../utils/common'
import { IGNORE_CHARACTER, MAX_INPUT_LENGTH } from '../constant'
import classes from '../index.module.scss'

export const EditName = ({
  originName,
  handleChangeName,
  clearError,
  disabled,
}) => {
  const typeFontSize = UseTypeFontSize()
  const theme = UseTheme()

  const [isEdit, setIsEdit] = useState(false)
  const [editName, setEditName] = useState(originName)

  const openEdit = () => {
    setIsEdit(true)
  }

  const closeEdit = () => {
    setEditName(originName)
    setIsEdit(false)
  }

  useEffect(() => {
    setEditName(originName)
  }, [originName])

  const onChangeName = (e) => {
    const value = e.target.value
      .slice(0, MAX_INPUT_LENGTH)
      .split('')
      .filter((c) => !IGNORE_CHARACTER.includes(c))
      .join('')
    setEditName(value)
    clearError()
  }

  const onSubmit = () => {
    handleChangeName(editName)
    closeEdit()
  }

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      onSubmit()
    }
    if (e.key === 'Escape') {
      closeEdit()
    }
  }

  return isEdit ? (
    <HandleClickOutside handleClickOutside={closeEdit}>
      <Element className={classes.editName} style={{ borderColor: '#2C73E8' }}>
        <input
          value={editName}
          onChange={onChangeName}
          autoFocus
          onFocus={(e) => e.target.select()}
          onKeyDown={onKeyDown}
          style={getStyle({ fontSize: 20 }, theme, typeFontSize)}
        />
        <Element className={classes.actionButtons}>
          <Element className={classes.button} onClick={closeEdit}>
            <Icon
              className="icon-delete"
              style={{ fontSize: 11, color: '#9C9C9C' }}
            />
          </Element>
          <Element className={classes.button} onClick={onSubmit}>
            <Icon
              className="icon-tick cursorPointer"
              style={{ fontSize: 13, color: '#3DA967' }}
            />
          </Element>
        </Element>
      </Element>
    </HandleClickOutside>
  ) : (
    <Element className="dFlex gap1 alignItemsCenter breakWordAll">
      <Element
        className="cursorPointer fw500"
        style={{ fontSize: 20, color: '#191D25' }}
      >
        <TextEllipsisStaticLine
          text={originName}
          isI18n={false}
          tooltipMaxWidthByContent
          zIndexTooltip={Z_INDEX.MODAL + 1}
        />
      </Element>
      {!disabled && (
        <Element>
          <Icon
            className="icon-edit-outline"
            style={{ fontSize: 18, color: '#D5D5D5' }}
            onClick={openEdit}
          />
        </Element>
      )}
    </Element>
  )
}
